import {OrdersController} from "../../orders_controller";

export default class extends OrdersController {
  static targets = ["delete_link"]

  destroyRent(event) {
    event.preventDefault();
    let url = event.currentTarget.getAttribute("data-url");
    this._delete(url);
  }

  //
  // Private
  //
  _delete(url) {
    let confirmMessage = this.data.get("confirm-text");
    if (confirm(confirmMessage)) {
      Rails.ajax({
        url: url,
        type: 'delete',
        success: (data) => {
          if (data) {
            super._successNotify(data.notification_title, data.notification_message);
            
            if (data.cell_data) {
              super._updateTableCell('transport--dispatchers-drivers-table', data.cell_data);
            }
          }
        },
        error: (data) => {
          if (data) {
            super._errorNotify(data.notification_title, data.notification_message);
          }
        }
      })
    }
  }
}